import React, { useEffect, useState } from 'react';
import { safeArray } from '../../components/ErrorBoundary';
import ProjectFilterSelect from '../../components/ProjectFilterSelect';
import ProjectNameText from '../../components/ProjectNameText';
import { useProjects } from '../../context/ProjectsContext';
import { submittalsAPI } from '../../services/authService';
import { formatDateTimeIN } from '../../utils/dateFormat';
import { formatSubmittalStatus } from './SubmittalStatusBadge';

const RevisionRegister = ({ onViewSubmittal }) => {
  const { projects } = useProjects();
  const [projectFilter, setProjectFilter] = useState('all');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      try {
        const params = { page: 1, pageSize: 200 };
        if (projectFilter !== 'all') params.projectId = projectFilter;
        const resp = await submittalsAPI.getReportRevisionHistory(params);
        if (!cancelled) setRows(safeArray(resp?.data?.data));
      } catch (err) {
        console.warn('Revision register load failed:', err?.message || err);
        if (!cancelled) setRows([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [projectFilter]);

  return (
    <div>
      <div className="page-header">
        <div>
          <h2>Revision Register</h2>
          <p style={{ color: '#6b7280', margin: 0 }}>Revision history across submittals.</p>
        </div>
      </div>

      <div className="filters-row" style={{ marginBottom: 16 }}>
        <ProjectFilterSelect value={projectFilter} onChange={setProjectFilter} projects={projects} />
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Submittal</th>
              <th>Project</th>
              <th>Revision</th>
              <th>Status</th>
              <th>Submitted By</th>
              <th>Submitted At</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} style={{ textAlign: 'center' }}>Loading...</td></tr>
            ) : rows.length === 0 ? (
              <tr><td colSpan={7} style={{ textAlign: 'center', color: '#6b7280' }}>No revisions found</td></tr>
            ) : rows.map((row) => (
              <tr
                key={`${row.submittal_id}-${row.revision_no}`}
                style={{ cursor: typeof onViewSubmittal === 'function' ? 'pointer' : 'default' }}
                onClick={() => onViewSubmittal?.(row.submittal_id)}
              >
                <td style={{ fontWeight: 600, color: '#7C3AED' }}>{row.submittal_no || row.subject || `#${row.submittal_id}`}</td>
                <td><ProjectNameText as="span">{row.project?.name || '—'}</ProjectNameText></td>
                <td>{row.revision_label || `R${row.revision_no}`}</td>
                <td>{formatSubmittalStatus(row.revision_status || row.status)}</td>
                <td>{row.submitted_by?.name || '—'}</td>
                <td>{formatDateTimeIN(row.submitted_at)}</td>
                <td>{row.remarks || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RevisionRegister;
